import { SET_COLUMN_STATE, SET_GROUP_STATE } from 'constants/actionTypes';

export default function gridState(state = {}, action) {
  switch (action.type) {
    case SET_COLUMN_STATE: {
      const { path, grid, columnState } = action;
      const pathGridState = (state[path] && state[path][grid]) || {};
      return {
        ...state,
        [path]: {
          ...state[path],
          [grid]: { ...pathGridState, columnState },
        },
      };
    }
    case SET_GROUP_STATE: {
      const { path, grid, groupState } = action;
      const pathGridState = (state[path] && state[path][grid]) || {};
      return {
        ...state,
        [path]: {
          ...state[path],
          [grid]: { ...pathGridState, groupState },
        },
      };
    }
    default:
      return state;
  }
}
